import React from 'react'
import PropTypes from 'prop-types'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import '../components/css/ToolTip.css'

class ToolTip extends React.Component 
{
    render() {

        const tip =
         (<Tooltip id='1'><div className='display-linebreak'>{this.props.tipText}</div></Tooltip>)

        return (

            <OverlayTrigger placement='right' overlay={tip}>
            {this.props.children}
            </OverlayTrigger>

        )

    }
}


ToolTip.propTypes = {
    tipIcon: PropTypes.string,
    tipText: PropTypes.string,
}
ToolTip.defaultProps = {
    tipIcon: '',
    tipText: 'Escape - Back to last page \n Right Arrow - Next Slide  Left Arrow - Previous Slide \n Space - Next Slide \n Shift+Space - Previous Slide \n Alt/Option + O - Toggle Overview Mode \nAlt/Option + P - Toggle Presenter Mode \n Alt/Option + T	- Toggle Timer in Presenter Mode \n',
}

export default ToolTip


// WEBPACK FOOTER //
// ./src/components/ToolTip.js